import { IconPropsType } from '..';

export const InfoIcon = ({ ...props }: IconPropsType) => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_7081_70584)">
      <g id="Vector">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M4.89995 0.700012C2.58036 0.700012 0.699951 2.58042 0.699951 4.90001V9.10001C0.699951 11.4196 2.58036 13.3 4.89995 13.3H9.09995C11.4195 13.3 13.3 11.4196 13.3 9.10001V4.90001C13.3 2.58042 11.4195 0.700012 9.09995 0.700012H4.89995ZM4.89995 2.10001C3.35355 2.10001 2.09995 3.35362 2.09995 4.90001V9.10001C2.09995 10.6464 3.35355 11.9 4.89995 11.9H9.09995C10.6463 11.9 11.9 10.6464 11.9 9.10001V4.90001C11.9 3.35362 10.6463 2.10001 9.09995 2.10001H4.89995Z"
        />
        <path d="M8.39995 5.60004L5.59995 5.60005V7.00004H6.29995V9.12804H5.59995V10.5L8.39995 10.5V9.12804L7.69995 9.10004V7.00004H8.39995V5.60004Z" />
        <path d="M6.29995 3.50004H7.69995V4.90004L6.29995 4.90004V3.50004Z" />
      </g>
    </g>
    <defs>
      <clipPath id="clip0_7081_70584">
        <rect
          width="14"
          height="14"
          fill="white"
        />
      </clipPath>
    </defs>
  </svg>
);
